import { IReportRequestData } from "src/app/models/reports";


export interface ReportRequestState {
    reportRequestData: IReportRequestData[];
    reportRequestDataLoaded: boolean;
    loading: boolean;
    error: boolean;
    errorMessage: string;
}

export const initialReportRequestState: ReportRequestState = {
    reportRequestData: [],
    reportRequestDataLoaded: false,
    loading: false,
    error: false,
    errorMessage: ''
};
